import { useMutation } from '@tanstack/react-query'
import { api } from '@api'

type InviteGhostToJoinVariables = {
  ghostProfileId: string
  // The language I use in the app: the invitation e-mail is written in it.
  language?: string
}

const inviteGhostToJoin = async ({
  ghostProfileId,
  language,
}: InviteGhostToJoinVariables): Promise<void> => {
  await api.post(`/ghost-profiles/${ghostProfileId}/invite-to-join`, { language })
}

export const useInviteGhostToJoin = () => {
  return useMutation<void, Error, InviteGhostToJoinVariables>({
    mutationFn: inviteGhostToJoin,
  })
}
